import { OpportunityStageEnum, VehicleEntity } from 'src/api';
import i18next from 'src/i18n';
import { isMarket } from 'src/utils/markets';
import { Markets } from 'src/types';
import { FunnelStep } from './types';
import { getMakeName } from 'src/motornet/common/MotornetVehicleSelector';

/**
 * In aggiunta alle tab Account, Opportunity e Veicolo (presenti in ogni stato), devono comparire dinamicamente i seguenti tab:
 * - Se viene selezionato "Proposta" mostrare il tab "Invia/Carica documenti"
 * - Se viene selezionato "Attesa" firma mostrare il tab "Invia documenti"
 * - Se viene selezionato "Al credito" mostrare il tab "Carica documenti"
 */
export function tabsByStage(stage: OpportunityStageEnum): FunnelStep[] {
	const tabs: FunnelStep[] = ['account', 'opportunity', 'vehicle'];
	switch (stage) {
		case OpportunityStageEnum.proposal:
			return tabs.concat(['send_or_upload_docs']);
		case OpportunityStageEnum.waiting_sign:
			return tabs.concat(['send_docs']);
		case OpportunityStageEnum.credit_score_check:
			return tabs.concat(['upload_docs']);
		default:
			return [];
	}
}

export const getVehicleLabel = (vehicle: VehicleEntity) => {
	return (
		(vehicle?.dati_veicolo?.marca || '') +
		' ' +
		(vehicle?.dati_veicolo?.modello || '')
	);
};

export const getExternalVehicleLabel = (vehicle: any, defaultLabel: string) => {
	return vehicle.model
		? `${getMakeName(vehicle?.brand)} ${vehicle?.model?.label}`
		: defaultLabel;
};

export const getDocumentsCountLabel = (arr: any[]) => {
	return arr.length
		? arr.length + ` document${arr.length === 1 ? 'o' : 'i'}`
		: i18next.t('no_document');
};

export const EMAIL_TEMPLATES = {
	uploadSendDocuments: {
		it: `
	Spett.le Cliente,
	<br>
	con la presente le invio il preventivo per la soluzione di noleggio da lei richiesta.
	<br>
	In attesa di un suo gentile riscontro resto a disposizione per ogni dubbio.
	<br>
	Cordiali saluti
	<br>
		`,
		es: `
	Estimado cliente,
	<br>
	por la presente le envío el presupuesto para la solución de alquiler que ha solicitado.
	<br>
	Esperando su amable respuesta, quedo a su disposición para cualquier consulta.
	<br>
	Un cordial saludo
	<br>`,
	},
};

export const getUploadSendDocumentsEmailTemplate = () => {
	return isMarket(Markets.es)
		? EMAIL_TEMPLATES.uploadSendDocuments.es
		: EMAIL_TEMPLATES.uploadSendDocuments.it;
};

export function toUpperCase(values: string): string;
export function toUpperCase(values: string[]): string[];
export function toUpperCase(values: string | string[]) {
	if (typeof values === 'string') {
		return values.trim().toUpperCase();
	}

	if (Array.isArray(values)) {
		return values.map((item) => item?.trim().toUpperCase());
	}

	throw new Error('Input must be a string or an array of strings');
}
